import { MenuItemProps } from './types';
import { MenuButton } from '../../atoms';

export const MenuItem = ({
    label,
    componentType,
    onItemClick,
    icon,
    active = false,
    indicatorActive = false,
    indicatorValue,
    indicatorLabel
}: MenuItemProps) => {
    return (
        <li key={componentType} className={`flex-1 ${active ? 'active' : ''}`}>
            <MenuButton
                classNames="group relative w-full h-full flex flex-col items-center justify-between text-sm font-medium font-accent px-2 pt-2 pb-1 whitespace-nowrap after:absolute after:bottom-0 after:left-2/4 after:w-full after:h-1 after:rounded-t-sm after:bg-accent after:-translate-x-2/4 after:scale-x-0 [.active_&]:after:scale-x-100 after:transition-transform after:duration-300 after:ease-in-out"
                onItemClick={() => onItemClick(componentType)}
                aria-current={active ? 'true' : undefined}
            >
                <span className="relative mb-1 after:absolute after:w-full after:h-full after:top-0.75 after:left-0.75 after:bg-accent-lighter after:rounded-sm after:scale-0 after:-z-1 after:transition-transform after:duration-200 after:ease-out-quint group-hover:after:scale-100 group-focus-visible:after:scale-100">
                    {icon}
                    {indicatorActive && (
                        <span className="absolute -top-0.5 left-5 min-w-5 h-5 font-medium text-sm text-white bg-warning rounded-full px-1.5" aria-hidden="true">
                            {indicatorValue ? indicatorValue.toString() : '!'}
                        </span>
                    )}
                </span>
                {label}
                {indicatorActive && indicatorLabel && <span className="sr-only">, {indicatorLabel}</span>}
            </MenuButton>
        </li>
    );
};
